<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-col h-full overflow-hidden">
    <!-- PO Detail Summary -->
    <div class="qb-detail-card qb-primary-tint p-4 mb-4 shrink-0">
      <div class="flex justify-between">
        <div class="qb-stacked-field">
          <div class="label">Account</div>
          <div class="value font-semibold">{{ poDetail.joDetail?.joHeader?.account?.accountName || 'N/A' }}</div>
        </div>
        <div class="qb-stacked-field">
          <div class="label">Description</div>
          <div class="value font-semibold">{{ poDetail.product?.productType?.description }}</div>
        </div>
        <div class="qb-stacked-field">
          <div class="label">SKU</div>
          <div class="value font-semibold">{{ poDetail.product?.productType?.style }}</div>
        </div>
        <div class="qb-stacked-field">
          <div class="label">Features</div>
          <div class="value font-semibold">{{ poDetail.product?.featureChoicesExtract }}</div>
        </div>
        <div class="qb-stacked-field text-center">
          <div class="label">Order</div>
          <div class="value font-semibold">{{ poDetail.orderQty }}</div>
        </div>
        <div class="qb-stacked-field text-center">
          <div class="label">Needed</div>
          <div class="value font-semibold">{{ poDetail.getRemainingQty() }}</div>
        </div>
      </div>
    </div>

    <!-- Apply Options -->
    <div class="flex flex-row gap-8 mb-4 shrink-0">
      <div class="flex flex-col gap-2">
        <div class="font-semibold mb-1">Apply To:</div>
        <div *ngIf="poDetail.getRemainingQty() > 0" class="flex items-center">
          <p-radioButton value="default" [(ngModel)]="applyTo" (ngModelChange)="applyToChanged($event)" inputId="default" />
          <label for="default" class="ml-2">Default</label>
        </div>
        <div *ngIf="poDetail.getRemainingQty() > 0 && !isAccountOwned" class="flex items-center">
          <p-radioButton value="stock" [(ngModel)]="applyTo" (ngModelChange)="applyToChanged($event)" inputId="stock" />
          <label for="stock" class="ml-2">Stock</label>
        </div>
        <div *ngIf="poDetail.getRemainingQty() > 0 && !isAccountOwned" class="flex items-center">
          <p-radioButton value="jod" [(ngModel)]="applyTo" (ngModelChange)="applyToChanged($event)" inputId="jod" />
          <label for="jod" class="ml-2">Job Order Detail</label>
        </div>
        <div *ngIf="poDetail.getRemainingQty() > 0" class="flex items-center">
          <p-radioButton value="cancel" [(ngModel)]="applyTo" (ngModelChange)="applyToChanged($event)" inputId="cancel" />
          <label for="cancel" class="ml-2">Cancel Order</label>
        </div>
        <div *ngIf="poDetail.getRemainingQty() > 0" class="flex items-center">
          <p-radioButton value="hold" [(ngModel)]="applyTo" (ngModelChange)="applyToChanged($event)" inputId="hold" />
          <label for="hold" class="ml-2">Hold Order</label>
        </div>
        <div *ngIf="poDetail.heldQty > 0" class="flex items-center">
          <p-radioButton value="unhold" [(ngModel)]="applyTo" (ngModelChange)="applyToChanged($event)" inputId="unhold" />
          <label for="unhold" class="ml-2">Unhold Order</label>
        </div>
      </div>
      <uni-field label="Quantity to apply">
        <input #qtyInput pInputText [(ngModel)]="applyQty" name="applyQty" (ngModelChange)="applyQtyChanged($event)" maxlength="4" size="6" title="Quantity to apply" />
      </uni-field>
    </div>

    <!-- Job Order Detail Grid -->
    <div *ngIf="applyTo === 'jod'" class="flex flex-col flex-1 min-h-0 overflow-hidden">
      <div class="mb-2 shrink-0">Select alternative Job Order Detail - matching styles/alt styles shown below</div>
      <app-ag-grid [gridOptions]="jodGridOptions" [rowData]="joDetails" class="flex-1 min-h-0"></app-ag-grid>
      <ng-template #altStyleCell let-row>
        <button pButton type="button" class="p-button-text p-button-sm" *ngIf="hasAltStyle(row)" (click)="showAltStyle(row)">Show</button>
      </ng-template>
    </div>

    <!-- Cancel Order Replacement Grid -->
    <div *ngIf="poDetail.joDetailId != null && applyTo === 'cancel'" class="flex flex-col flex-1 min-h-0 overflow-hidden">
      <div class="mb-2 shrink-0">Select replacement for cancelled items</div>
      <app-ag-grid [gridOptions]="issGridOptions" class="flex-1 min-h-0"></app-ag-grid>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button [disabled]="applyQty == null || applyQty == 0"  (click)="apply()" pButton type="button" class="p-button-raised">Apply</button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised">Cancel
  </button>
  </div>
</ng-template>
